/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Add_Child_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a league to add..." |
*
* @param {League_Add_Child_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_add_child_placeholder = /** @type {((inputs?: League_Add_Child_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Add_Child_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner une ligue à ajouter...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar una liga para añadir...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Selecionar uma liga para adicionar...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un campionato da aggiungere...")
	return /** @type {LocalizedString} */ ("Select a league to add...")
});